/**
 * PAWTY neobrutalist — Popular Products tabs.
 *
 * Every tab's product grid is already rendered into the DOM by
 * sections/pawty-popular-products.liquid (one <collection>.products loop per
 * block, no extra network requests). This custom element only toggles which
 * panel is visible and keeps the tab buttons' active/aria state in sync —
 * no full page reload, no per-tab fetch.
 */
(function () {
  if (customElements.get('pawty-nb-tabs')) return;

  class PawtyNbTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pawty-nb-tab'));
      this.panels = Array.from(this.querySelectorAll('.pawty-nb-tab-panel'));
      this._onClick = this.onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    onClick(event) {
      const tab = event.target.closest('.pawty-nb-tab');
      if (!tab || !this.tabs.includes(tab)) return;
      event.preventDefault();
      this.selectTab(tab);
    }

    selectTab(tab) {
      if (tab.classList.contains('is-active')) return;
      const targetId = tab.getAttribute('data-tab-target');

      this.tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === targetId);
      });
    }
  }

  customElements.define('pawty-nb-tabs', PawtyNbTabs);
})();
